import "./footer.style.css"

export const Footer = () => {
    return (
        <footer className="footer">
            Made with ❤
        </footer>
    )
}
